import React, { Component } from "react";
import { connect } from "react-redux";
import NavbarContainer from "../../Navbar/NavbarContainer";
import Profile from "./Profile";
import PageInfo from "../../UIComponents/PageInfo/PageInfo";
import "./Profile.scss";
import VideoModal from "../../MainContent/RawData/VideoModal/VideoModal";
import profileicon from "../../../assets/svg/profile-userWhite.svg";
import Tour_profile from "../TourFiles/Tour_profile";
import Tour_profile_0 from "../TourFiles/Tour_profile_0";
class ProfileContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showVideWalkthroughModal: false,
        };
    }

    render() {
        let tourComponent = Tour_profile;
        if (!this.props.switchCompanyAvailable) tourComponent = Tour_profile_0;
        return (
            <div className="Profile">
                <NavbarContainer
                    history={this.props.history}
                    location={this.props.location}
                    pageTitle="Profile"
                    icon={profileicon}
                    tourComponent={tourComponent}
                />
                {/* <PageInfo
                    pageInfo=" When setting up your profile please ensure that your timezone is set to your current location as all posts, reports and alerts will be determined by the timezone selected here."
                    url="https://www.youtube.com/embed/XjoZXDast64"
                /> */}
                <Profile
                    company={this.props.company}
                    userEmail={this.props.userEmail}
                    userName={this.props.userName}
                    auto_push_enabled={this.props.auto_push_enabled}
                    getUrl={this.props.profilePic}
                />
                <VideoModal
                    open={this.state.showVideWalkthroughModal}
                    hideModal={() => this.setState({ showVideWalkthroughModal: false })}
                    videoData={{ url: "https://www.youtube.com/embed/XjoZXDast64", platformName: "Walkthrough" }}
                />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        userEmail: state.globalReducer.userEmail,
        profilePic: state.globalReducer.profilePic,
        userName: state.globalReducer.userName,
        company: state.globalReducer.company,
        activeIndex: state.trendsReducer.trendsTabIndex,
        auto_push_enabled: state.globalReducer.auto_push_enabled,
        switchCompanyAvailable: state.globalReducer.switchCompanyAvailable,
    };
};

export default connect(mapStateToProps)(ProfileContainer);
